import { gql } from '@apollo/client';

import { BREAKDOWN_FIELDS } from 'gql/breakdownFragment';

export const CREATE_BREAKDOWN = gql`
	mutation createBreakdown(
		$input: BreakdownInput!
		$overlappingActivityAction: OverlappingActivityAction
		$delayMinutes: Int
	) {
		createBreakdown(
			input: $input
			overlappingActivityAction: $overlappingActivityAction
			delayMinutes: $delayMinutes
		) {
			__typename
			... on BreakdownSuccessResponse {
				breakdown {
					...BreakdownFields
				}
			}
			... on BreakdownErrorResponse {
				errors
				workAssignmentErrors
			}
			... on BreakdownOverlappingActivitiesResponse {
				overlappingActivities {
					fromTimestamp
					toTimestamp
					isCancellable
					activity {
						... on CrewMemberWorkAssignmentActivityItem {
							title
							rideId
							deadheadId
							activityType
							status
							fromStation {
								id
								name
								code
								timezone
							}
							toStation {
								id
								name
								code
								timezone
							}
							note
							run {
								id
								name
							}
							job {
								id
								code
							}
						}
						... on CrewMemberAbsenceActivityItem {
							reason {
								id
								name
							}
							note
						}
						... on CrewMemberBreakActivityItem {
							breakType
						}
					}
				}
				minDelayMinutes
				maxDelayMinutes
			}
		}
	}
	${BREAKDOWN_FIELDS}
`;

export const CREATE_BREAKDOWN_RESPONSE_TYPES = {
	success: 'BreakdownSuccessResponse',
	error: 'BreakdownErrorResponse',
	overlapping: 'BreakdownOverlappingActivitiesResponse',
};
